"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionStorageFeatureProvider = exports.localStorageFeatureProvider = exports.configFeatureProvider = exports.locationSearchFeatureProvider = void 0;
function locationSearchFeatureProvider(name) {
    return window.location.search.includes("featureToggles.".concat(name));
}
exports.locationSearchFeatureProvider = locationSearchFeatureProvider;
function configFeatureProvider(_a) {
    var featureToggles = _a.featureToggles;
    return function (name) {
        return featureToggles && featureToggles[name] ? true : false;
    };
}
exports.configFeatureProvider = configFeatureProvider;
function localStorageFeatureProvider(name) {
    return localStorage.getItem("featureToggles.".concat(name)) ? true : false;
}
exports.localStorageFeatureProvider = localStorageFeatureProvider;
function sessionStorageFeatureProvider(name) {
    return sessionStorage.getItem("featureToggles.".concat(name)) ? true : false;
}
exports.sessionStorageFeatureProvider = sessionStorageFeatureProvider;
